export default "__VITE_ASSET__CK_lD0E7__"